import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-date-range-picker',
  templateUrl: './date-range-picker.component.html',
  styleUrls: ['./date-range-picker.component.scss'],
})
export class DateRangePickerComponent implements OnInit {
  @Input() datePickerPlacement = 'left';
  @Input() dateCustomClasses;
  @Input() toDate;
  @Input() fromDate;
  @Input() downloadToDate;
  @Input() downloadFromDate;
  @Output() valueChange = new EventEmitter<Date[]>();
  bsRangeValue: Date[];
  bsConfig: any;

  ngOnInit() {
    this.bsRangeValue = [
      new Date(
        (this.downloadFromDate || this.fromDate)._d ||
          this.downloadFromDate ||
          this.fromDate,
      ),
      new Date(
        (this.downloadToDate || this.toDate)._d ||
          this.downloadToDate ||
          this.toDate,
      ),
    ];
  }
  onValueChange(value: Date[]): void {
    this.valueChange.emit(value);
  }
}
